import { __awaiter } from "tslib";
import { ModuleFileService } from "@/servicesTs/models/general/moduleFile";
const moduleModuleFile = {
    namespaced: true,
    state: {
        loading: false,
        moduleFile: [],
    },
    getters: {
        getLoading(state) {
            return state.loading;
        },
        getModuleFile(state) {
            return state.moduleFile;
        },
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        setModuleFile(state, data) {
            state.moduleFile = data;
        },
    },
    actions: {
        getModuleFile({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                const MODULE_FILE = yield ModuleFileService.getAll();
                commit("setModuleFile", MODULE_FILE);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleModuleFile;
